import React, { useState, useContext } from "react";
import { storage, db } from "../firebaseConfig";
import { UserContext } from "../user";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
    Link,
} from "react-router-dom";
import ShowColumn from "../components/showColumn";
import { Button } from "react-bootstrap";
import FooterNew from "../Footers/Footer";
export default function ThirtyDayQuestion({

}) {

    return (
        <div>
            <h1 class="center">30days, 30 questions, 30 prizes</h1>
        </div>
    );
}
